/*
 * Author: zoesvision.com
 * Purpose: Control standalone Footer accordions, success dialog, and Back to top.
 */

(() => {
  class ZFooter extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      this.abortController = new AbortController();
      this.dialog = this.querySelector('[data-z-footer-dialog]');
      this.emailInput = this.querySelector('input[type="email"]');
      this.menuToggles = [...this.querySelectorAll('[data-z-footer-menu-toggle]')];
      const { signal } = this.abortController;

      this.menuToggles.forEach((toggle, index) => {
        this.setMenuState(toggle, index === 0);
        toggle.addEventListener('click', () => {
          this.setMenuState(toggle, toggle.getAttribute('aria-expanded') !== 'true');
        }, { signal });
      });

      this.querySelector('[data-z-footer-dialog-close]')?.addEventListener(
        'click',
        () => this.closeDialog(),
        { signal }
      );
      this.dialog?.addEventListener('click', (event) => this.onDialogClick(event), { signal });
      this.dialog?.addEventListener('close', () => this.emailInput?.focus(), { signal });
      this.querySelector('[data-z-footer-back-to-top]')?.addEventListener(
        'click',
        () => this.scrollToTop(),
        { signal }
      );

      this.setAttribute('data-z-footer-ready', '');
      this.openDialog();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
      this.removeAttribute('data-z-footer-ready');
    }

    setMenuState(toggle, expanded) {
      const panel = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
      toggle.setAttribute('aria-expanded', String(expanded));
      if (panel) panel.hidden = !expanded;
    }

    openDialog() {
      if (!this.dialog) return;
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
    }

    closeDialog() {
      if (!this.dialog) return;
      if (typeof this.dialog.close === 'function') this.dialog.close();
      else {
        this.dialog.removeAttribute('open');
        this.emailInput?.focus();
      }
    }

    onDialogClick(event) {
      const bounds = this.dialog.getBoundingClientRect();
      const outside = event.clientX < bounds.left
        || event.clientX > bounds.right
        || event.clientY < bounds.top
        || event.clientY > bounds.bottom;
      if (outside) this.closeDialog();
    }

    scrollToTop() {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  }

  if (!customElements.get('z-footer')) customElements.define('z-footer', ZFooter);
})();
